import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

type Props = {
  onActionEditar: (idMateriaisControlados: number | null, openState: boolean) => void;
  onActionDeletar: (idMateriaisControlados: number | null, openState: boolean) => void;
  onActionDownload: (idMateriaisControlados: number, nomeArquivo: string) => void;
};

export const GenerateControleColumnDefinition = ({ onActionEditar, onActionDeletar, onActionDownload }: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: string | boolean) => {
    if (status === true || status === "A") return "Ativo";
    if (status === false || status === "I") return "Inativo";
    return "?";
  };

  const computeItemStatusColor = (status: string | boolean) => {
    if (status === true || status === "A") return "green";
    if (status === false || status === "I") return "red";
    return "blue";
  };

  const computeItemStatusDescription = (status: string | boolean) => {
    if (status === true || status === "A") return "Ativo";
    if (status === false || status === "I") return "Inativo";
    return "?";
  };

  return [
    {
      field: "ativo",
      filterable: false,
      headerName: "Status",
      minWidth: 90,
      width: 90,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)}
          />
        </div>
      ),
    },
    {
      field: "nroMaterial",
      filterable: false,
      headerName: "Nº",
      minWidth: 75,
      sortable: false,
      headerClassName: "equipamento-header",
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: "equipamento-header",
    },
    {
      field: "arquivo",
      filterable: false,
      headerName: "Arquivo",
      width: 175,
      sortable: false,
      resizable: false,
      valueGetter: (_, rows) => ({
        nomeArquivo: rows["nomeArquivo"],
        idMateriaisControlados: rows["idMateriaisControlados"],
      }),
      renderCell: (params) => {
        const maxSize = 20;
        const idMateriaisControlados = params.value["idMateriaisControlados"] as number;
        const nomeArquivo = params.value["nomeArquivo"] as string;
        return (
          <Button
            onMouseDown={() => onActionDownload(idMateriaisControlados, nomeArquivo)}
            sx={{
              fontSize: 11,
              paddingX: ".4rem",
              paddingY: 0,
              background: "#e6e6e6",
              borderLeft: ".3rem solid #45b6af",
              borderRadius: 0,
              color: "black",
              fontWeight: "normal",
              width: "9.5rem",
            }}
          >
            {nomeArquivo && nomeArquivo.length > maxSize ? `${nomeArquivo.substring(0, maxSize)}...` : nomeArquivo}
          </Button>
        );
      },
    },
    {
      field: "idMateriaisControlados",
      headerName: "Ações",
      sortable: false,
      filterable: false,
      width: 100,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.row.idMateriaisControlados, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
          </IconButton>

          <IconButton onClick={() => onActionDeletar(params.row.idMateriaisControlados, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
